import { render } from "./HomeComponent.vue?vue&type=template&id=3fe42014"
const script = {}

import exportComponent from "/Users/luismanuel/Documents/www/adminmkthl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__